import api from "api";
export function getPyamentsDashboard(payload){
    return api.post(`/dashboards`, payload)
}
